__turbopack_context__.v({
  "appear": "NotifyMeModal-module__2tlAmq__appear",
  "blok-big-title": "NotifyMeModal-module__2tlAmq__blok-big-title",
  "blok-subtitle": "NotifyMeModal-module__2tlAmq__blok-subtitle",
  "blok-title": "NotifyMeModal-module__2tlAmq__blok-title",
  "details": "NotifyMeModal-module__2tlAmq__details",
  "errorMessage": "NotifyMeModal-module__2tlAmq__errorMessage",
  "form": "NotifyMeModal-module__2tlAmq__form",
  "formSection": "NotifyMeModal-module__2tlAmq__formSection",
  "formTitle": "NotifyMeModal-module__2tlAmq__formTitle",
  "imageContainer": "NotifyMeModal-module__2tlAmq__imageContainer",
  "input": "NotifyMeModal-module__2tlAmq__input",
  "productInfo": "NotifyMeModal-module__2tlAmq__productInfo",
  "productMeta": "NotifyMeModal-module__2tlAmq__productMeta",
  "productName": "NotifyMeModal-module__2tlAmq__productName",
  "root": "NotifyMeModal-module__2tlAmq__root",
  "submitButton": "NotifyMeModal-module__2tlAmq__submitButton",
  "successMessage": "NotifyMeModal-module__2tlAmq__successMessage",
});
